'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addMessageToStubbedThread = undefined;

var _reduxActions = require('redux-actions');

var _StubbedThreadHistoryActionTypes = require('../constants/StubbedThreadHistoryActionTypes');

var addMessageToStubbedThread = exports.addMessageToStubbedThread = (0, _reduxActions.createAction)(_StubbedThreadHistoryActionTypes.ADD_MESSAGE_TO_STUBBED_CHANNEL, function (message) {
  return { message: message };
});


//////////////////
// WEBPACK FOOTER
// ./js/stubbed-thread-history/actions/addMessageToStubbedThread.js
// module id = 137
// module chunks = 2 3